import React from 'react'
import PropTypes from 'prop-types'
import { Popover, OverlayTrigger } from 'react-bootstrap'
import './CustomOverlayTrigger.sass'

const CustomOverlayTrigger = (props) => {
    const { children, title, body, closeBtn, trigger, placement, prefix } = props

	const closePopover = (e) => {
		e.preventDefault();
        document.body.click()
		// document.getElementById("advanced-player-mp4videos").style.display = "none";
	}

    const popover = (
		<Popover id="popover-trigger-status-definitions" bsPrefix={`popover custom-overlay-trigger ${prefix && prefix}`}>
			<Popover.Header as="h3">
                {title}
                {closeBtn && 
                    <button type="button" variant="close" className="close-btn" onClick={closePopover}>
                        <span aria-hidden="true">×</span>
                    </button>
                }
            </Popover.Header>
			<Popover.Body>
                <span dangerouslySetInnerHTML={{ __html: body }} />
			</Popover.Body>
		</Popover>
	)

	return (
		<OverlayTrigger
            // show={true}
			trigger={trigger || 'hover'}
			rootClose
			placement={placement || 'top'}
			overlay={popover}
		>
			{children}
		</OverlayTrigger>
	)
};

CustomOverlayTrigger.propTypes = {
	title: PropTypes.string.isRequired,
	body: PropTypes.string.isRequired,
}

export default CustomOverlayTrigger
